import React from 'react';
import { Box, Tab, Tabs } from '@material-ui/core';

export const FormTabs = ({ activeTab, handleTabChange, children }) => {
    return (
        <Tabs
            value={activeTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleTabChange}
            aria-label="disabled tabs example"
            style={{
                backgroundColor: '#f7f7ff',
            }}
        >
            {children}
        </Tabs>
    );
};

FormTabs.Tab = ({ title, ...other }) => {
    return (
        <Tab
            label={
                <span
                    style={{
                        fontFamily: 'Nunito',
                        fontSize: 16,
                        fontWeight: 'bold',
                        textTransform: 'none',
                    }}
                >
                    {title}
                </span>
            }
            style={{
                minWidth: '33%',
            }}
            {...other}
        />
    );
};

export default function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            style={{ padding: '8px 24px' }}
            {...other}
        >
            {value === index && <Box style={{ marginTop: 20 }}>{children}</Box>}
        </div>
    );
}
